import { MetricPipe } from '../../pipes/metric/metric';
import { LocationProvider } from '../../providers/location/location';
import { Component, OnInit } from '@angular/core';
import {NavController, NavParams, Platform, ToastController} from 'ionic-angular';
import { MyEventsProvider } from '../../providers/my-events/my-events';
import { EventsList, DataEntity } from './../../models/events.list.model';
import {tap} from "rxjs/operators";
import {FcmProvider} from "../../providers/fcm/fcm";
import {ContactRequest} from "../../models/user.model";
import {ContactRequestPage} from "../../pages/contact-request/contact-request";
import {MessagePage} from "../../pages/message/message";
import {MessengerPage} from "../../pages/messenger/messenger";
import { GeoFenceProvider } from '../../providers/geo-fence/geo-fence';
import { CurrentEventProvider } from '../../providers/current-event/current-event';

/**
 * Generated class for the EventsFeedComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'events-feed',
  templateUrl: 'events-feed.html',
})
export class EventsFeedComponent implements OnInit {
  cardItems: any[];
  eventsFeed: DataEntity[];
  activeEvent: EventsList[];
  joinedEvents: EventsList[];
  page = 0;
  pageSize = 4;
  totalPages: number = 0;
  countryCode = 'RS';

  constructor(
    private navCtrl: NavController,
    private navParams: NavParams,
    private myEventsProvider: MyEventsProvider,
    private locationProvider: LocationProvider,
    private metric: MetricPipe,
    private toastController: ToastController,
    private platform: Platform,
    private geoFenceProvider: GeoFenceProvider,
    private currentEventProvider: CurrentEventProvider
  ) {

  }

  ngOnInit(): void {
    this.currentEventProvider.setCurrentEvent({});
    // this.geoFenceProvider.readAndSendLocation();
    this.locationProvider.getLocation().subscribe(
      res => {
        this.countryCode = res.country;
        this.loadEvents();
      },
      error => {
        this.loadEvents();
      }
    );
  }

  loadEvents(): void {
    this.myEventsProvider
      .nearByEvents(this.countryCode, this.page, this.pageSize)
      .subscribe(res => {
        this.eventsFeed = res.data;
        this.totalPages = res.totalPages;
        this.page = res.pageNumber;
        // console.log(JSON.stringify(res, null, 2));
      });
  }

  // loadActive(): void {
  //   this.myEventsProvider
  //     .eventsLista('CURRENT')
  //     .subscribe((events: EventsList[]) => {
  //       this.activeEvent = events;
  //       console.log('activeEvent', this.activeEvent.length);

  //       this.joinedEvents = this.activeEvent.filter(event => {
  //         return event.joinedOnEvent;
  //       });
  //     });
  // }
  doInfinite(infiniteScroll) {
    this.page++;
    setTimeout(() => {
      this.myEventsProvider
        .nearByEvents(this.countryCode, this.page, this.pageSize)
        .subscribe(res => {
          this.eventsFeed.push(...res.data);
          this.totalPages = res.totalPages;
          this.page = res.pageNumber;
          infiniteScroll.complete();
        });
    }, 0);
  }

  /**
   * Navigate to the detail page for this item.
   */
  openItem(pin: string, joined: boolean, closed: boolean) {
    if (joined && !closed) {
      this.navCtrl.setRoot('EventMasterPage', {
        pin: pin,
      });
    } else {
      this.navCtrl.push('EventDetailsPage', {
        pin: pin,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/events-feed/events-feed.ts